import { type FC, useCallback } from "react";

import { useLensManagementRoutes } from "../../../../core/routes/hooks";
import { truncate } from "../../../../shared/styles";
import { type LensCard } from "../../../models";

import { LensCardPreview } from "./LensCardPreview";
import { LensIcon, LensInfo, LensName, LensStat, NameAndValue, TopLensCardContainer } from "./TopLensCard.styles";

interface TopLensCardProps {
    lens: LensCard;
}

export const TopLensCard: FC<TopLensCardProps> = ({ lens }) => {
    const { goToLensPage } = useLensManagementRoutes();

    const onLensCardClick = useCallback(() => {
        goToLensPage(lens.id);
    }, [lens, goToLensPage]);

    return (
        <TopLensCardContainer className="top-lens-card_container" onClick={onLensCardClick}>
            <LensCardPreview preview={lens.preview} />
            <LensInfo>
                <LensIcon src={lens.icon} />
                <NameAndValue>
                    <LensName className={truncate}>{lens.name}</LensName>
                    <LensStat>{lens.value}</LensStat>
                </NameAndValue>
            </LensInfo>
        </TopLensCardContainer>
    );
};
